import download from 'downloadjs';

document.addEventListener('DOMContentLoaded', () => {
  const downloads = document.querySelectorAll('[data-download]');

  downloads.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();

      const path = item.dataset.download;

      if (!path || !path.length) return;

      download(path);
    });
  });
});
